var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import * as React from 'react';

function SvgAlertDanger(props) {
  return React.createElement("svg", __assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32"
  }, props), React.createElement("path", {
    fill: "#FFF",
    fillRule: "evenodd",
    d: "M10.355 1.45h11.29c.362 0 .709.14.965.387l7.99 7.75c.256.247.4.583.4.934V21.47c0 .35-.144.687-.4.935l-7.99 7.749a1.386 1.386 0 01-.965.387h-11.29c-.362 0-.709-.14-.965-.387l-7.99-7.75a1.302 1.302 0 01-.4-.934V10.52c0-.35.144-.687.4-.935l7.99-7.749c.256-.248.603-.387.965-.387zm.564 2.645l-7.192 6.974v9.853l7.192 6.974h10.162l7.192-6.974V11.07L21.08 4.095H10.919zm3.717 6.611c0-.73.61-1.322 1.364-1.322.753 0 1.364.592 1.364 1.322v5.29c0 .73-.61 1.322-1.364 1.322-.753 0-1.364-.592-1.364-1.323v-5.289zm.4 10.191a1.294 1.294 0 010-1.87 1.394 1.394 0 011.928 0 1.294 1.294 0 010 1.87 1.394 1.394 0 01-1.928 0z"
  }));
}

export default SvgAlertDanger;